export const config = ['config'];
export const pluginRef = ['plugin'];
export const ASSETS = ['assets'];
export const components = ['components'];
